import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { PanelCollapseToggle } from '../leftVerticalToolbar';
import { ComposerSelectionFooter } from './composerWorkspace';

// LE COLONNE DEL COMPOSER SI CHIUDONO COME QUELLE DELLO SCENE EDITOR (utente, 2026-10-15): lo stesso
// chevron in fondo — `PanelCollapseToggle`, quello del rail e del piede dell'Inspector della scena —,
// la stessa preferenza (`preferences.collapsed`), e da chiusa la colonna resta larga quanto il rail,
// con il chevron e basta. Il contenuto resta montato e nascosto: riaprire ritrova il lavoro com'era.
//
// IL CHEVRON STA DOVE C'È POSTO, in due modi:
//     band  in fondo al pannello si riserva una fascia, come il piede dell'Inspector della scena;
//     hint  sulla riga della nota sui gesti, a sinistra, come il chevron del rail accanto alla nota
//           della lista nella scena: la nota si sposta di quanto è largo il rail.

const Column = styled.section<{ $collapsed: boolean; $foot: 'band' | 'hint'; $rail: number }>`
    position: relative;
    display: flex;
    min-width: 0;
    min-height: 0;
    height: 100%;
    flex-direction: column;

    > [data-column-content] {
        display: ${(props) => (props.$collapsed ? 'none' : 'flex')};
        min-width: 0;
        min-height: 0;
        flex: 1;
        flex-direction: column;

        > * {
            flex: 1;
            min-height: 0;
        }
    }

    ${(props) =>
        props.$foot === 'band' &&
        css`
            > [data-column-content] > * {
                padding-bottom: 44px;
            }
        `}

    ${(props) =>
        props.$foot === 'hint' &&
        css`
            ${ComposerSelectionFooter} {
                padding-left: ${props.$rail}px;
            }
        `}

    /* Chiusa, la colonna è una striscia: la card vuota con il chevron in fondo. */
    ${(props) =>
        props.$collapsed &&
        css`
            background: var(--editor-panel, #ffffff);
            border: 1px solid var(--editor-line, #d1d3d8);
            border-radius: 16px;
            box-shadow: var(--composer-shadow, rgba(38, 50, 56, 0.04) 0 1px 2px);
        `}
`;

const Foot = styled.div<{ $side: 'left' | 'right'; $rail: number; $bottom: number }>`
    position: absolute;
    bottom: ${(props) => props.$bottom}px;
    ${(props) => props.$side}: 0;
    z-index: 2;
    display: flex;
    justify-content: center;
    width: ${(props) => props.$rail}px;
`;

export const ComposerCollapsibleColumn: FC<{
    collapsed: boolean;
    /** Da che parte si chiude: decide il posto del chevron e il suo verso, come nella scena. */
    side: 'left' | 'right';
    railWidth: number;
    foot: 'band' | 'hint';
    onToggle: () => void;
    children: React.ReactNode;
}> = ({ collapsed, side, railWidth, foot, onToggle, children }) => (
    <Column $collapsed={collapsed} $foot={foot} $rail={railWidth}>
        <div data-column-content=''>{children}</div>
        <Foot $side={side} $rail={railWidth} $bottom={foot === 'hint' && !collapsed ? 4 : 8}>
            <PanelCollapseToggle collapsed={collapsed} side={side} onToggle={onToggle} />
        </Foot>
    </Column>
);
